// Set document.domain for cross-subdomain communication
// This must run early, before any other scripts that might need it
document.domain = 'utexas.edu';
